import { Theme } from "./types";

const DarkTheme: Theme = {
  title: 'dark',

  colors: {
    primary: '#744cb4',
    primary_hover: '#8c62d1',
    red_brand: '#F51010',

    background: '#282A36',
    card: '#42485a',
    card_300: '#39485e',
    text: '#FFFFFF',
    grey_text: '#FFFFFF',
    white: '#FFFFFF',

    positive: '#16a34a',
    negative: '#E83A3A',
    warning: '#FA871D',
    neutral: '#1D75FA',

    border_grey: '#586680',
    primary_tranparent: 'rgba(124, 192, 255, 0)',
    hover: '#4f5e73',

    dev: "yellow",
  }
}

export { DarkTheme };